import React from 'react'
import commonImage from './Images/commonImage.svg'
import testQuoteWhite from './Images/Test Quote White.png'
const TestimonialCards = ({ image, name, description }) => {
    return (
        <div className="testimonialCard">
            <div className="testimonial-card-header">
                <img src={image} alt={name} className='nameImages' />
                <div className="quote-icon-container">
                    <img src={testQuoteWhite} alt="quote" className="quote-icon" />
                </div>
            </div>
            <h3 className='testimonialClientName'>{name}</h3>
            <p className='testimonialClientDesc'>{description}</p>
        </div>
    )
}

export default TestimonialCards
